import { PageHeader } from "../../components/HeaderComponents"
import { AnnouncementsComponent } from "../../components/AnnouncementsComponents"
import { requestAnnouncements, requestEmployeeAnnouncements } from "../../requests/setup_requests"
import { TicketCountGraph, TicketStatsOverview, UserStatsOverview } from "../../components/DashboardComponents"
import { Trans, useTranslation } from "react-i18next"
import { useContext, useEffect, useState } from "react"
import { BreadCrumbsGeneral } from "../../components/NavigationComponents"
import { NotificationContext } from "../../contexts/NotificationContexts"
import { ChangelogComponent } from "../../components/ChangelogComponents"
import { PermissionContext } from "../../contexts/PermissionContexts"
import { requestFetchServerStatus } from "../../requests/system_requests"



export const DashboardPage = () => {
    const { t } = useTranslation('dashboard')
    const { isSidebar, setIsSidebar } = useContext(NotificationContext)
    const { hasPermission } = useContext(PermissionContext)
    const [serverStatus, setServerStatus] = useState({})

    useEffect(() => {
        if (!isSidebar) {
            setIsSidebar(true)
        }

        requestFetchServerStatus({})
            .then((data) => {
                setServerStatus(data.server_stats)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
    }, [])

    const breadCrumbs = [
        {
            link: "/admin/dashboard",
            name: t("Home")
        },
        {
            link: null,
            name: t("Dashboard")
        }
    ]

    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <PageHeader pageTitle={t('Dashboard')} />
            <div className="w-full">
                <h1 className="text-xl font-semibold">{t('Dashboard')}</h1>
                <BreadCrumbsGeneral elements={breadCrumbs} />

            </div>
            <div className="flex flex-col w-full gap-10 mt-7 mb-12">
                {
                    serverStatus?.show &&
                    <div role="alert" className="alert alert-warning max-w-[1200px]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <span>
                            <Trans t={t} i18nKey={'server_capacity_warning'} values={{ capacity: serverStatus?.capacity }} />
                        </span>
                    </div>
                }
                <div className="flex flex-col w-full gap-5">
                    {
                        hasPermission("announcement:view") &&
                        <div className="flex flex-col gap-2">
                            <span className="font-semibold text-lg">{t('Employee Announcements')}</span>
                            <AnnouncementsComponent isEmployee fetchCall={requestEmployeeAnnouncements} showNoAnnouncementsMessage={true} />
                        </div>
                    }

                    {
                        hasPermission("announcement:view") &&
                        <div className="flex flex-col gap-2">
                            <span className="font-semibold text-lg">{t('Player Announcements')}</span>
                            <AnnouncementsComponent fetchCall={requestAnnouncements} showNoAnnouncementsMessage={true} />
                        </div>
                    }
                </div>
                {
                    hasPermission("stats:view") &&
                    <>
                        <div className="flex flex-col gap-2">
                            <span className="font-semibold text-lg">{t('User Overview')}</span>
                            <UserStatsOverview />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span className="font-semibold text-lg">{t('Tickets Overview')}</span>
                            <TicketStatsOverview />
                        </div>

                        <div className="flex flex-col gap-2">
                            <span className="font-semibold text-lg">{t('Ticket Count')}</span>
                            <TicketCountGraph />
                        </div>
                    </>
                }

                <div className="flex flex-col gap-2 mt-10">
                    <span className="font-semibold text-lg">{t('Changelog')}</span>
                    <ChangelogComponent />
                </div>
            </div>
        </div>
    )
}